import { CHANGE_FORM_TAB } from './';

export default payload => ({ type: CHANGE_FORM_TAB, payload });
